import { defaultTranslations, translationsNamespace } from './defaultTranslations';

export const defaultTranslationsWithNamespaces = {
  [translationsNamespace]: defaultTranslations,
};
